module.exports = __webpack_public_path__ + "static/media/AL.85cd136d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/AL.svg
// module id = 188
// module chunks = 0